import { render, staticRenderFns } from "./ReportCheckListServiceObject.vue?vue&type=template&id=252dda3d&"
import script from "./ReportCheckListServiceObject.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListServiceObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem,QInput} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QInput}, component.options.components || {})
